<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="list-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="afterCloseDialog"
  >
    <div class="search-content write-order">
      <el-row>
        <!--@keyup.enter.native="bindGrid"-->
        <el-row>
          <el-col :span="24" class="toobar">
            <el-col :span="5">
              <AutoCustomer ref="autocustomer" @handleSelect="select" :splitByAddress="true" ></AutoCustomer>
            </el-col>
            <!--<div style="float: right;width: 1411px;">-->
            <el-col :span="18">
              <el-select v-model="cangkucode" @change="changeCangKu"
                         v-if="deliveryaddress==''?false:true"
                         style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode">
                </el-option>
              </el-select>
              <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                          :isShowCheckBox="false" :treeWidth="550"
                          style="width: 200px;display: block;margin: auto;float: left;margin-left: 30px;"
                          :treeHeight="500" :searchText="seedname"
                          @check="checktree1"></CommonTree>
              <el-input v-model="tracknum" ref="tracknum" placeholder="请填写供应商单号" @change="tracknumsubmit" clearable
                        onfocus="this.select()"
                        style="width: 160px"></el-input>
              <el-input v-model="logisticstracknum" ref="logisticstracknum" placeholder="请填写跟踪单号" clearable
                        onfocus="this.select()"
                        @change="logisticstracknumsubmit"
                        style="width: 160px"></el-input>
            </el-col>
            <!--</div>-->
          </el-col>
        </el-row>
        <el-row>
          <div style="float: left;margin-top: 8px;font-size: larger;margin-left: 5px"
               v-if="deliveryaddress==''?false:true"> 门店：<span>{{this.deptname}}</span>&nbsp;&nbsp;收货地址：<span>{{this.deliveryaddress}}</span>
          </div>
        </el-row>
      </el-row>
      <el-row>
        <el-col :span="24">
          <iframe width=100% scrolling="Auto" id="iframe" ref="iframe"
                  :height="tableHeight(122)" frameborder="0" name="writeorder" @click="isshow"></iframe>
        </el-col>
      </el-row>
    </div>

    <HsCstagreementList ref="HsCstagreementList"></HsCstagreementList>
  </el-dialog>
</template>
<script>

  import {getListData, deleteData, getpinyinlistData} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';
  import {simulationLogin} from '@/api/login';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import HsCstagreementList from './HsCstagreementList';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';

  export default {
    inject: ["afterCloseDialog"],
    name: 'HelloWorld',
    data() {
      return {
        openURL: 'HsTuiHuoXianPianApp',
        activeIndex: '1',
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        servedserial: "",
        idd: [],
        tableData: [],
        pinyinData: [],
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        couponServedserial: '',//独立核算
        deliveryaddress: '',//收货地址
        deptname: '',
        loginName: '',
        customerserial: '',
        restaurants: [],
        timeout: null,
        elinkman: '',
        elinkmantel: '',
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        seedcode: '',
        seedname: '',
        jxcstoreData: [],//仓库数组
        cangkucode: '',//选中的仓库
        cangkuname: '',
        roletype: '',//岗位类型
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial: {//上级客户编码
        default: ""
      },
      filterbyservedserial: {//根据当前登录人所属的加工中心过滤数据
        default: false
      },
      storeInfo: {
        default: ""
      }
    },
    methods: {
      //iframe 子类调用的方法（退货成功后用）
      isshow() {
        this.dialogFormVisible = false
        this.$emit("bindGrid")//刷新页面
      },
      tracknumsubmit() {
        localStorage.setItem('tracknum', this.tracknum.trim());
        this.$refs.logisticstracknum.focus()
      },
      logisticstracknumsubmit() {
        localStorage.setItem('logisticstracknum', this.logisticstracknum.trim());
      },
      //商品选择后执行的方法
      checktree1(guids, names, arr) {
        this.seedcode = guids
        this.seedname = names
        this.filltemplate = arr[0].attributes['filltemplate']

        var writeorder = null;
        if (this.openURL == 'HsTuiHuoXianPianApp') {
          this.openURL = "HsTuiHuoXianPianAppch";
        } else {
          this.openURL = "HsTuiHuoXianPianApp";
        }

        writeorder = window.open("http://" + window.location.host + "/#/app/" + this.openURL + "?sename=" + this.seedname + "&seedcode=" + this.seedcode.replace(/\+/g, "%2B").replace(/=/g, "%3D") + "&filltemplate=" + this.filltemplate, 'writeorder', "")

        if (writeorder && writeorder.open && !writeorder.closed) {
          writeorder.moveTo(-4, -4);
          writeorder.resizeTo(screen.availWidth + 8, screen.availHeight + 8);
        }
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree()
        })

      },
      //远程搜索
      loadAll() {
        for (let i = 0; i < this.pinyinData.length; i++) {
          this.pinyinData[i].value = this.pinyinData[i].fpinyin
        }
      },
      //远程搜索
      querySearchAsync(queryString, cb) {
        var results = this.pinyinData;
        if (queryString.length > 3) {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 300 * Math.random());
        }
      },
      //远程搜索
      handleSelect(item) {
        if (!item.unitguid) {
          this.$refs.hide1.focus()
          this.bindGrid()
        } else {
          this.searchdata = item.deptname + "(" + item.deliveryaddress + ")"
          //处理选中之后的地址session问题
          this.select(item);
        }

      },

      //客户地址
      select(customerserial, customername, row) {
        this.deliveryaddress = row.deliveryaddress
        this.elinkman = row.linkman
        this.elinkmantel = row.linkmantel
        this.deptname = row.deptname
        this.customerserial = row.customerserial
        //客户信息
        simulationLogin({loginName: this.loginName, customerserial: this.customerserial}).then(response => {
          if (response.data.code == 0) {
            this.jxcstoreData.forEach(o => {
              if (o.cangkucode == this.cangkucode) {
                this.cangkuname = o.cangkuname
              }
            })
            localStorage.setItem('hpweb_token', response.data.token); //兼容vue端的相关页面
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', window.location.host);
            localStorage.setItem('deliveryaddress', this.deliveryaddress);
            localStorage.setItem('elinkman', this.elinkman);
            localStorage.setItem('elinkmantel', this.elinkmantel);
            localStorage.setItem('cangkucode', this.cangkucode);
            localStorage.setItem('cangkuname', this.cangkuname);
            localStorage.setItem('roletype', this.roletype);
            localStorage.setItem('settingmenthod', row.settingmenthod);

          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
      },
      showdailog(groupguid) {
        this.$refs.HsCstagreementList.bindGrid(groupguid)
      },
      bindGrid() {
        this.pinyinData = []
        if (this.searchdata.length < 4) {
          this.$message({
            message: '至少四位',
            type: 'warning',
            duration: '1500',
          })
          return
        }

        getpinyinlistData({
          search: this.searchdata.toLocaleLowerCase(),
          unitgroup: this.myunitgroup,
          servedserial: this.servedserial,
          parentcustomerserial: this.parentcustomerserial,
          coupon: this.coupon,
          province: this.province,//省
          city: this.city,//市
          county: this.county,//县
          couponServedserial: this.couponServedserial,//独立核算
        }).then(response => {
          this.pinyinData = response.data.obj
          this.loadAll();
          this.$refs.droplist1.focus()
        }).catch((error) => {
          console.log(error)
        });
      },
      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
      },
      changeCangKu() {
        localStorage.setItem('cangkucode', this.cangkucode);
        this.jxcstoreData.forEach(o => {
          if (o.cangkucode == this.cangkucode) {
            this.cangkuname = o.cangkuname
          }
        })
        localStorage.setItem('cangkuname', this.cangkuname);
        try {
          window.writeorder.window.refreshErWeiTable()
        } catch (ee) {
        }
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
      show(unitgroup, title, roletype) {
        if(this.$refs.autocustomer){
          this.$refs.autocustomer.clearContent();
        }
        this.seedname = ''
        this.searchdata = ''//选中的门店
        this.deliveryaddress = ''//收货地址
        this.restaurants = []
        this.pinyinData = []
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.couponServedserial = ''//独立核算
        this.roletype = ''
        this.logisticstracknum = ''
        this.tracknum = ''
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }

        this.mytitle = '退货单'

        if (roletype) {
          this.roletype = roletype
        }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }
        this.cusandptbyind();

      },
      cusandptbyind() {
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          } else {
            this.cangkucode = this.jxcstoreData[0].cangkucode
          }
        })

      },

    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.servedserial = this.userInfoModel.independentserial;
      //默认值
      if (!this.userInfoModel.independentserial) {
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            this.idd.unshift({serialnum: "all", dname: "全部"})
            this.servedserial = 'all';
          }

        })
      }
    },
    components: {
      HsCstagreementList,
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

  .name {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .addr {
    font-size: 12px;
    color: #b4b4b4;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WriteReturnOrder.vue